<template>
  <component
    :is="VTextField"
    variant="outlined"
    clearable
    density="compact"
    class="analyze-search-input"
    :hide-details="hideDetails"
    :prepend-inner-icon="CONSTANTS.ICONS_MDI.ICON_MAGNIFY"
  >
    <template v-if="dateRangePicker" #append>
      <v-overlay
        v-model="dateRangeOverlay"
        location-strategy="connected"
        :scrim="false"
        scroll-strategy="reposition"
        attach
      >
        <template #activator>
          <v-btn
            variant="outlined"
            class="h-100"
            :prepend-icon="CONSTANTS.ICONS_MDI.ICON_CALENDAR_REMOVE_OUTLINE"
            @click.prevent="dateRangeOverlay = !dateRangeOverlay"
          >
            <slot name="date-range-label">Date range</slot>
          </v-btn>
        </template>

        <VueDatePicker
          id="date-picker"
          :model-value="initialDateRange"
          range
          inline
          :auto-apply="true"
          :enable-time-picker="false"
          @update:model-value="updateDateRange($event)"
        />
      </v-overlay>
    </template>
  </component>
</template>

<script lang="ts" setup>
  import { VTextField } from 'vuetify/components/VTextField'
  import CONSTANTS from '@/constants/Config.constants'
  import { ref } from 'vue'
  import VueDatePicker from '@vuepic/vue-datepicker'

  defineProps({
    initialDateRange: { type: Object as () => [Date, Date], default: undefined },
    dateRangePicker: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
  })

  const emit = defineEmits<{
    (event: 'input:dateRange', value: [Date, Date]): void
  }>()

  const dateRangeOverlay = ref(false)

  function updateDateRange($event: [Date, Date]): void {
    dateRangeOverlay.value = false
    emit('input:dateRange', $event)
  }
</script>

<style lang="scss" scoped>
  .analyze-search-input {
    color: rgb(var(--v-theme-font-color));
    caret-color: rgb(var(--v-theme-primary));
  }
</style>
